window.BookingV2 = (function() {
  var Booking = {};
  Booking.Collections = {};
  Booking.Models = {};
  Booking.Presenters  = {};
  Booking.Views = {};var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Booking.Collections.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Collection.apply(this, arguments);
    this._meta = {};
    this.on('request', this.loading);
    this.on('sync', this.loaded);
    this.on('error', this.loaded);
  }

  Base.prototype.meta = function(prop, value) {
    if (value !== void 0) {
      this._meta[prop] = value;
    }
    return this._meta[prop];
  };

  Base.prototype.loading = function() {
    return this.meta('loaded', false);
  };

  Base.prototype.loaded = function() {
    return this.meta('loaded', true);
  };

  Base.prototype.isLoading = function() {
    return this.meta('loaded') === false;
  };

  Base.prototype.isLoaded = function() {
    return this.meta('loaded') === true;
  };

  return Base;

})(Backbone.Collection);

Booking.Models.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Model.apply(this, arguments);
    if (typeof this.error === 'function') {
      this.on('error', this.error, this);
    }
  }

  Base.prototype.sync = function(method, model, options) {
    if (options == null) {
      options = {};
    }
    options.beforeSend = function(xhr) {
      if (Booking.csrf) {
        xhr.setRequestHeader('x-csrf-token', Booking.csrf);
      }
      if (Booking.authToken) {
        return xhr.setRequestHeader('x-auth-token', Booking.authToken);
      }
    };
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  };

  return Base;

})(Backbone.Model);

Booking.Presenters.Base = (function() {
  Base.prototype.module = 'booking';

  function Base(options1, templateName1) {
    var ref, ref1, ref2;
    this.options = options1;
    this.templateName = templateName1;
    if (this.module == null) {
      this.module = (ref = this.options) != null ? ref.module : void 0;
    }
    this.model = (ref1 = this.options) != null ? ref1.model : void 0;
    this.collection = (ref2 = this.options) != null ? ref2.collection : void 0;
    this.localesBasePath = "modules." + this.module + "." + this.templateName;
  }

  Base.prototype.toHash = function() {};

  Base.prototype.getI18n = function(scope) {
    if (scope == null) {
      scope = this.localesBasePath;
    }
    if (scope != null) {
      return I18n.scoped(scope);
    }
    return I18n;
  };

  Base.prototype.toHashWithHelpers = function() {
    return I18n.mixin(this.toHash(), this.getI18n());
  };

  Base.prototype.generateLink = function(i18nKey, href) {
    var label;
    label = this.getI18n().t(i18nKey);
    return "<a href='" + href + "'>" + label + "</a>";
  };

  return Base;

})();

Booking.Views.Base = (function(superClass) {
  extend(Base, superClass);

  Base.prototype.module = 'booking';

  function Base(options1) {
    this.options = options1 != null ? options1 : {};
    _.extend(this, _.pick(this.options, ['templateName', 'module', 'presenter']));
    Backbone.View.apply(this, arguments);
  }

  Base.prototype.template = function() {
    return window.BookingTemplates[this.module + "_frontend_templates_" + this.templateName];
  };

  Base.prototype.getPresenter = function() {
    if (this.presenter) {
      if (this._presenter == null) {
        this._presenter = new this.presenter(this.options, this.templateName);
      }
      return this._presenter;
    }
  };

  Base.prototype.templateAttributes = function() {
    if (this.presenter) {
      return this.getPresenter().toHashWithHelpers();
    } else {
      return this.options;
    }
  };

  Base.prototype.toHtml = function() {
    if (this.template()) {
      return this.template().render(this.templateAttributes());
    } else {
      return "";
    }
  };

  Base.prototype.render = function() {
    this.$el.html(this.toHtml());
    return this;
  };

  Base.prototype.bhw = function(widget) {
    var ref;
    return (ref = this.$el) != null ? ref.attr('data-bhw', widget) : void 0;
  };

  Base.prototype.translate = function() {
    var i18n;
    i18n = this.getPresenter().getI18n();
    return i18n.translate.apply(i18n, arguments);
  };

  return Base;

})(Backbone.View);

Booking.Models.Attribute = (function(superClass) {
  extend(Attribute, superClass);

  function Attribute() {
    return Attribute.__super__.constructor.apply(this, arguments);
  }

  Attribute.prototype.getLabel = function() {
    return this.get('label');
  };

  Attribute.prototype.getName = function() {
    return this.get('name');
  };

  Attribute.prototype.getType = function() {
    return this.get('type');
  };

  Attribute.prototype.isRequired = function() {
    return true;
  };

  Attribute.prototype.validate = function(value) {
    return value.match(this.get('validation')) != null;
  };

  Attribute.prototype.isPhone = function() {
    return this.getName() === 'phone_number';
  };

  Attribute.prototype.isPartySize = function() {
    return this.getName() === 'party_size';
  };

  Attribute.prototype.isQuestion = function() {
    return this.getType() === 'question';
  };

  Attribute.prototype.allowedValues = function() {
    var ref, ref1;
    return (ref = this.getType().match(/^enumeration\((.*)\)$/)) != null ? (ref1 = ref[1]) != null ? ref1.split(';') : void 0 : void 0;
  };

  return Attribute;

})(Booking.Models.Base);

Booking.Models.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.loaded = false;

  function Booker(arg) {
    var deal;
    deal = arg.deal;
    Booking.Models.Base.apply(this, arguments);
    if (this.get('timezoneData') != null) {
      moment.tz.add(this.get('timezoneData'));
    }
    this.set({
      options: new Booking.Collections.Options,
      availability: new Booking.Collections.Availability,
      times: new Booking.Collections.Times,
      reservations: new Booking.Collections.Reservations,
      partySizes: new Booking.Collections.PartySizes
    });
    this.getAvailability().getTimezone = (function(_this) {
      return function() {
        return _this.getTimezone();
      };
    })(this);
    this.getTimes().getTimezone = (function(_this) {
      return function() {
        return _this.getTimezone();
      };
    })(this);
    this.getTimes().isARSE = (function(_this) {
      return function() {
        return _this.isARSE();
      };
    })(this);
    this.getReservations().on('request', this.booking, this).on('sync', this.booked, this).on('error', this.handleError, this);
    this.getOptions().on('reset', (function(_this) {
      return function() {
        return _this.resetOption();
      };
    })(this));
    this.on('change:selectedOption', this.selectedOptionChanged, this);
    this.resetOptions(deal.options);
    this.resetPartySize();
  }

  Booker.prototype.handleError = function() {
    return this.notBooking();
  };

  Booker.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Booker.prototype.clearError = function() {
    return this.unset('error');
  };

  Booker.prototype.getError = function() {
    return this.get('error');
  };

  Booker.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Booker.prototype.getOrderId = function() {
    return this.get('orderId');
  };

  Booker.prototype.getGrouponId = function() {
    return this.get('grouponId');
  };

  Booker.prototype.getUserId = function() {
    return this.get('userId');
  };

  Booker.prototype.getDeal = function() {
    return this.get('deal');
  };

  Booker.prototype.getOptions = function() {
    return this.get('options');
  };

  Booker.prototype.getTimes = function() {
    return this.get('times');
  };

  Booker.prototype.getAvailability = function() {
    return this.get('availability');
  };

  Booker.prototype.getReservations = function() {
    return this.get('reservations');
  };

  Booker.prototype.resetReservations = function(reservations) {
    if (reservations == null) {
      reservations = [];
    }
    this.getReservations().reset(reservations);
    return this;
  };

  Booker.prototype.getReservation = function() {
    return this.getReservations().first();
  };

  Booker.prototype.createReservation = function() {
    this.setReservation(new Booking.Models.Reservation);
    return this.getReservation();
  };

  Booker.prototype.setReservation = function(reservation) {
    this.resetReservations([reservation]);
    return this;
  };

  Booker.prototype.unsetReservation = function() {
    this.resetReservations();
    return this;
  };

  Booker.prototype.getTimezone = function() {
    return this.getCurrentOption().getLocalBookingSettings().getTimezone();
  };

  Booker.prototype.getMerchantPhoneNumber = function() {
    var ref;
    return (ref = this.getCurrentOption().getRedemptionLocation()) != null ? ref.phoneNumber : void 0;
  };

  Booker.prototype.hasMultipleOptions = function() {
    return this.getOptions().length > 1;
  };

  Booker.prototype.preSelectedOption = function() {
    return this.getOptions().get(this.get('optionId'));
  };

  Booker.prototype.getSettingsDefinitionVersion = function() {
    return this.getCurrentOption().getLocalBookingSettings().getDefinitionVersion();
  };

  Booker.prototype.getPartySizeSettings = function() {
    return this.getCurrentOption().getPartySizeSettings();
  };

  Booker.prototype.getPhoneSettings = function() {
    return this.getCurrentOption().getPhoneSettings();
  };

  Booker.prototype.getQuestionsSettings = function() {
    return this.getCurrentOption().getQuestionsSettings();
  };

  Booker.prototype.getFirstQuestionSettings = function() {
    var ref;
    return (ref = this.getQuestionsSettings()) != null ? ref[0] : void 0;
  };

  Booker.prototype.getQuestion = function() {
    var ref;
    return (ref = this.getFirstQuestionSettings()) != null ? ref.getLabel() : void 0;
  };

  Booker.prototype.requirePartySize = function() {
    var ref;
    return (ref = this.getPartySizeSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requirePhone = function() {
    var ref;
    return (ref = this.getPhoneSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requireQuestion = function() {
    var ref;
    return (ref = this.getFirstQuestionSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.reset = function() {
    this.resetOption();
    return this.resetTime();
  };

  Booker.prototype.resetOptions = function(options) {
    this.getOptions().reset(options);
    return this;
  };

  Booker.prototype.resetOption = function() {
    var defaultOption;
    defaultOption = !this.hasMultipleOptions() ? this.getOptions().firstSelectable() : null;
    return this.selectOption(this.preSelectedOption() || defaultOption);
  };

  Booker.prototype.resetPartySize = function() {
    var currentSelection, partySizes, ref;
    if (this.requirePartySize()) {
      currentSelection = this.selectedPartySize();
      partySizes = this.getPartySizeSettings().allowedValues();
      this.get('partySizes').reset(partySizes);
      if (ref = currentSelection != null ? currentSelection.toString() : void 0, indexOf.call(partySizes, ref) >= 0) {
        return this.selectPartySize(currentSelection);
      }
    }
  };

  Booker.prototype.resetDate = function() {
    this.selectDate(null);
    return this;
  };

  Booker.prototype.resetTime = function() {
    this.selectTime(null);
    return this;
  };

  Booker.prototype.selectOption = function(option) {
    return this.set({
      selectedOption: option
    });
  };

  Booker.prototype.selectedOption = function() {
    return this.get('selectedOption');
  };

  Booker.prototype.selectedOptionChanged = function() {
    this.resetPartySize();
    return this.loadAvailability();
  };

  Booker.prototype.getCurrentOption = function() {
    return this.selectedOption() || this.getOptions().firstSelectable();
  };

  Booker.prototype.selectDate = function(selection) {
    var date, events, selectedDate;
    events = [];
    selectedDate = null;
    if (selection != null) {
      events = selection.events, date = selection.date;
      selectedDate = {
        date: date
      };
    }
    this.resetTime();
    this.getTimes().reset(events);
    return this.set({
      selectedDate: selectedDate
    });
  };

  Booker.prototype.selectTime = function(time) {
    return this.set({
      selectedTime: time
    });
  };

  Booker.prototype.selectedTime = function() {
    return this.get('selectedTime');
  };

  Booker.prototype.selectPartySize = function(partySize) {
    if (!(partySize instanceof Booking.Models.PartySize)) {
      partySize = new Booking.Models.PartySize(partySize);
    }
    return this.set({
      selectedPartySize: partySize
    });
  };

  Booker.prototype.selectedPartySize = function() {
    var ref;
    return (ref = this.get('selectedPartySize')) != null ? ref.getPartySize() : void 0;
  };

  Booker.prototype.setPhoneNumber = function(phoneNumber) {
    return this.set({
      phoneNumber: phoneNumber
    });
  };

  Booker.prototype.getPhoneNumber = function() {
    return this.get('phoneNumber');
  };

  Booker.prototype.setQuestionsAnswer = function(questionsAnswer) {
    return this.set({
      questionsAnswer: questionsAnswer
    });
  };

  Booker.prototype.getQuestionsAnswer = function() {
    return this.get('questionsAnswer');
  };

  Booker.prototype.isDealNotYetOpen = function() {
    var ref;
    return ((ref = this.getDeal()) != null ? ref.status : void 0) === 'not_yet';
  };

  Booker.prototype.isBookAndBuy = function() {
    return this.get('bookAndBuy');
  };

  Booker.prototype.isReschedule = function() {
    return this.get('reschedule');
  };

  Booker.prototype.isARSE = function() {
    var ref;
    return (ref = this.getCurrentOption()) != null ? ref.isARSE() : void 0;
  };

  Booker.prototype.loadAvailability = function() {
    var segments;
    if (this.selectedOption()) {
      this.getTimes().reset();
      segments = this.selectedOption().getAvailability();
      if (segments != null) {
        this.getAvailability().set(segments);
        this.getAvailability().trigger('sync');
      } else {
        this.getAvailability().fetch({
          reset: true,
          data: {
            initialTime: moment().format(),
            finalTime: moment().endOf('month').add('months', 3).format(),
            optionId: this.selectedOption().get('uuid')
          }
        });
      }
      return this;
    }
  };

  Booker.prototype.preset = function(arg) {
    var datetime, option, optionId, partySize, phoneNumber, questionsAnswer, setDateTime;
    datetime = arg.datetime, optionId = arg.optionId, partySize = arg.partySize, questionsAnswer = arg.questionsAnswer, phoneNumber = arg.phoneNumber;
    if (datetime) {
      this.selectDate({
        events: [],
        date: true
      });
      this.selectTime(true);
      setDateTime = (function(_this) {
        return function() {
          var date, events;
          date = moment.unix(datetime).tz(_this.getTimezone());
          events = _this.getAvailability().getTimesByDate(date);
          if (events.length) {
            _this.selectDate({
              date: date,
              events: events
            });
            return _this.selectTime(_.find(events, function(event) {
              return event.get('initialTimeMoment').unix() === parseInt(datetime, 10);
            }));
          } else {
            _this.resetDate();
            return _this.resetTime();
          }
        };
      })(this);
      if ((this.selectedOption() != null) && (this.selectedOption().getAvailability() != null)) {
        setDateTime();
      } else {
        this.getAvailability().once('sync', setDateTime);
      }
    }
    if (optionId) {
      option = this.getOptions().get(optionId);
      if (option) {
        this.selectOption(option);
      }
    }
    if (partySize) {
      this.selectPartySize(partySize);
    }
    if (phoneNumber) {
      this.setPhoneNumber(phoneNumber);
    }
    if (questionsAnswer) {
      return this.setQuestionsAnswer(questionsAnswer);
    }
  };

  Booker.prototype.booking = function() {
    return this.set({
      isBooking: true
    });
  };

  Booker.prototype.booked = function() {
    if (!this.isBookAndBuy()) {
      return this.notBooking();
    }
  };

  Booker.prototype.notBooking = function() {
    return this.set({
      isBooking: false
    });
  };

  Booker.prototype.isBooking = function() {
    return this.get('isBooking') === true;
  };

  Booker.prototype.isReadyToBook = function() {
    var needPhoneNumber, needQuestionsAnswers;
    needPhoneNumber = this.requirePhone() && !this.getPhoneNumber();
    needQuestionsAnswers = this.requireQuestion() && !this.getQuestionsAnswer();
    if (this.isDealNotYetOpen()) {
      return false;
    }
    return (this.selectedTime() != null) && (this.selectedOption() != null) && !needPhoneNumber && !needQuestionsAnswers;
  };

  Booker.prototype.book = function() {
    var reservation, reservationData, selectedOption;
    if (this.isReadyToBook()) {
      this.booking();
      reservation = this.getReservation() || this.createReservation();
      selectedOption = this.selectedOption();
      reservationData = {
        definitionVersion: this.getSettingsDefinitionVersion(),
        segmentId: this.selectedTime().id,
        dealId: this.getDeal().id,
        optionId: selectedOption.id,
        orderId: this.getOrderId(),
        userId: this.getUserId()
      };
      if (this.requirePartySize()) {
        reservationData[this.getPartySizeSettings().getName()] = this.selectedPartySize();
      }
      if (this.requirePhone()) {
        reservationData[this.getPhoneSettings().getName()] = this.getPhoneNumber();
      }
      if (this.requireQuestion()) {
        reservationData[this.getFirstQuestionSettings().getName()] = this.getQuestionsAnswer();
      }
      reservation.set(reservationData);
      if (!reservationData.orderId) {
        reservation.unset('id');
      }
      return reservation.save();
    }
  };

  return Booker;

})(Booking.Models.Base);

Booking.Models.LocalBookingSettings = (function(superClass) {
  extend(LocalBookingSettings, superClass);

  function LocalBookingSettings() {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(this.attributes));
  }

  LocalBookingSettings.prototype.parse = function(raw) {
    if (!raw) {
      return;
    }
    raw.additional_attributes = new Booking.Collections.Attributes(raw.additional_attributes);
    return raw;
  };

  LocalBookingSettings.prototype.getDefinitionVersion = function() {
    return this.get('definition_version');
  };

  LocalBookingSettings.prototype.getDuration = function() {
    return parseInt(this.get('duration'), 10);
  };

  LocalBookingSettings.prototype.getTentativeWindowDuration = function() {
    return parseInt(this.get('tentative_window_duration'), 10);
  };

  LocalBookingSettings.prototype.getTimezone = function() {
    return this.get('time_zone');
  };

  LocalBookingSettings.prototype.isARSE = function() {
    return this.getDuration() - this.getTentativeWindowDuration() !== 0;
  };

  LocalBookingSettings.prototype.getAdditionalAttributes = function() {
    return this.get('additional_attributes');
  };

  LocalBookingSettings.prototype.getAvailability = function() {
    return this.get('availability');
  };

  return LocalBookingSettings;

})(Booking.Models.Base);

Booking.Models.Option = (function(superClass) {
  extend(Option, superClass);

  Option.prototype.idAttribute = 'uuid';

  function Option() {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(this.attributes));
  }

  Option.prototype.parse = function(raw) {
    if (!raw) {
      return;
    }
    raw.localBookingSettings = new Booking.Models.LocalBookingSettings(raw.localBookingSettings);
    return raw;
  };

  Option.prototype.getTitle = function() {
    return this.get('title');
  };

  Option.prototype.getRedemptionLocation = function() {
    return this.get('redemptionLocations')[0];
  };

  Option.prototype.getLocationName = function() {
    var ref;
    return (ref = this.getRedemptionLocation()) != null ? ref.name : void 0;
  };

  Option.prototype.getPrice = function() {
    return this.get('price').amount;
  };

  Option.prototype.getFormattedPrice = function() {
    return this.get('price').formattedAmount;
  };

  Option.prototype.getFormattedValue = function() {
    return this.get('value').formattedAmount;
  };

  Option.prototype.isSoldOut = function() {
    return this.get('isSoldOut');
  };

  Option.prototype.getDiscount = function() {
    return this.get('discount');
  };

  Option.prototype.isFoodAndDrink = function() {
    return this.get('bookable');
  };

  Option.prototype.getLocalBookingSettings = function() {
    return this.get('localBookingSettings');
  };

  Option.prototype.getAvailability = function() {
    return this.getLocalBookingSettings().getAvailability();
  };

  Option.prototype.getAdditionalAttributes = function() {
    return this.getLocalBookingSettings().getAdditionalAttributes();
  };

  Option.prototype.isARSE = function() {
    return this.getLocalBookingSettings().isARSE();
  };

  Option.prototype.getPartySizeSettings = function() {
    return this.getAdditionalAttributes().getPartySize();
  };

  Option.prototype.getPhoneSettings = function() {
    return this.getAdditionalAttributes().getPhone();
  };

  Option.prototype.getQuestionsSettings = function() {
    return this.getAdditionalAttributes().getQuestions();
  };

  return Option;

})(Booking.Models.Base);

Booking.Models.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    arguments[0] = {
      partySize: parseInt(arguments[0], 10)
    };
    Booking.Models.Base.apply(this, arguments);
  }

  PartySize.prototype.getPartySize = function() {
    return this.get('partySize');
  };

  return PartySize;

})(Booking.Models.Base);

Booking.Models.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  Reservation.prototype.statuses = {
    locked: 'locked',
    requested: 'requested',
    confirmed: 'confirmed',
    expired: 'expired',
    canceled: 'user_declined'
  };

  function Reservation(attributes) {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(attributes));
    this.on('error', this.handleError, this);
    this.on('request', this.loading, this);
    this.on('sync', this.loaded, this);
  }

  Reservation.prototype.parse = function(raw) {
    var additionalAttributes, option;
    if (!raw) {
      return;
    }
    additionalAttributes = raw.additionalAttributes, option = raw.option;
    raw.additionalAttributes = new Booking.Collections.Attributes(additionalAttributes);
    raw.option = new Booking.Models.Option(option);
    return raw;
  };

  Reservation.prototype.handleError = function(model, response) {
    var error, errors;
    errors = {
      0: 'timeout',
      404: 'not_found',
      409: 'conflict',
      410: 'gone',
      504: 'timeout'
    };
    error = errors[response.status] || 'server';
    return this.setError(error);
  };

  Reservation.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Reservation.prototype.getError = function() {
    return this.get('error');
  };

  Reservation.prototype.clearError = function() {
    return this.unset('error');
  };

  Reservation.prototype.getOption = function() {
    return this.get('option');
  };

  Reservation.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Reservation.prototype.getUserId = function() {
    return this.get('userId');
  };

  Reservation.prototype.getStatus = function() {
    return this.get('status');
  };

  Reservation.prototype.getStartDatetime = function() {
    return this.get('startDatetime');
  };

  Reservation.prototype.getEndDatetime = function() {
    return this.get('endDatetime');
  };

  Reservation.prototype.getStartDatetimeMoment = function() {
    return moment(this.getStartDatetime()).tz(this.getTimezone());
  };

  Reservation.prototype.getEndDatetimeMoment = function() {
    return moment(this.getEndDatetime()).tz(this.getTimezone());
  };

  Reservation.prototype.getDuration = function() {
    return this.get('duration');
  };

  Reservation.prototype.isAppointmentRequest = function() {
    return this.get('tentativeWindow');
  };

  Reservation.prototype.getTimezone = function() {
    return this.getOption().getLocalBookingSettings().getTimezone();
  };

  Reservation.prototype.getLocationName = function() {
    return this.getOption().getLocationName();
  };

  Reservation.prototype.getMerchantName = function() {
    return this.getMerchant().name;
  };

  Reservation.prototype.getAttributes = function() {
    return this.get('additionalAttributes');
  };

  Reservation.prototype.getPartySize = function() {
    var ref;
    return this.get((ref = this.getAttributes().getPartySize()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.getQuestion = function() {
    var ref, ref1;
    return this.get((ref = this.getAttributes().getQuestions()) != null ? (ref1 = ref[0]) != null ? ref1.getName() : void 0 : void 0);
  };

  Reservation.prototype.getPhone = function() {
    var ref;
    return this.get((ref = this.getAttributes().getPhone()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.isLocked = function() {
    return this.getStatus() === this.statuses.locked;
  };

  Reservation.prototype.isRequested = function() {
    return this.getStatus() === this.statuses.requested;
  };

  Reservation.prototype.isConfirmed = function() {
    return this.getStatus() === this.statuses.confirmed;
  };

  Reservation.prototype.isExpired = function() {
    return this.getStatus() === this.statuses.expired;
  };

  Reservation.prototype.isCanceled = function() {
    return this.getStatus() === this.statuses.canceled;
  };

  Reservation.prototype.isBooked = function() {
    return this.isRequested() || this.isConfirmed() || this.isLocked();
  };

  Reservation.prototype.loaded = function() {
    return this.set('loaded', true);
  };

  Reservation.prototype.loading = function() {
    return this.set('loaded', false);
  };

  Reservation.prototype.isLoaded = function() {
    return this.get('loaded') === true;
  };

  Reservation.prototype.isLoading = function() {
    return this.get('loaded') === false;
  };

  Reservation.prototype.cancel = function() {
    this.set({
      status: this.statuses.canceled
    });
    return this.save();
  };

  return Reservation;

})(Booking.Models.Base);

Booking.Models.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    var clndrTimeMoment, finalTimeMoment, initialTimeMoment;
    Booking.Models.Base.apply(this, arguments);
    initialTimeMoment = clndrTimeMoment = moment.unix(this.get('initial_time'));
    finalTimeMoment = moment.unix(this.get('final_time'));
    if (this.collection && !this.collection.meta('browserInMerchantTimezone')) {
      initialTimeMoment = initialTimeMoment.tz(this.collection.getTimezone());
      finalTimeMoment = finalTimeMoment.tz(this.collection.getTimezone());
    }
    this.set({
      initialTimeMoment: initialTimeMoment,
      finalTimeMoment: finalTimeMoment,
      clndrTimeMoment: clndrTimeMoment
    });
  }

  Time.prototype.start = function() {
    return this.get('initialTimeMoment');
  };

  Time.prototype.end = function() {
    return this.get('finalTimeMoment');
  };

  return Time;

})(Booking.Models.Base);

Booking.Collections.Attributes = (function(superClass) {
  extend(Attributes, superClass);

  function Attributes() {
    return Attributes.__super__.constructor.apply(this, arguments);
  }

  Attributes.prototype.model = Booking.Models.Attribute;

  Attributes.prototype.getPhone = function() {
    return this.find(function(attribute) {
      return attribute.isPhone();
    });
  };

  Attributes.prototype.getPartySize = function() {
    return this.find(function(attribute) {
      return attribute.isPartySize();
    });
  };

  Attributes.prototype.getQuestions = function() {
    return this.filter(function(attribute) {
      return attribute.isQuestion();
    });
  };

  return Attributes;

})(Booking.Collections.Base);

Booking.Collections.Availability = (function(superClass) {
  extend(Availability, superClass);

  function Availability() {
    return Availability.__super__.constructor.apply(this, arguments);
  }

  Availability.prototype.model = Booking.Models.Time;

  Availability.prototype.url = function() {
    return Booking.rootUrl + "/availability";
  };

  Availability.prototype.parse = function(arg) {
    var segments;
    segments = arg.segments;
    this.meta('browserInMerchantTimezone', moment().zone() === moment().tz(this.getTimezone()).zone());
    return segments;
  };

  Availability.prototype.getTimesByDate = function(day) {
    var endOfDay, startOfDay;
    startOfDay = day.startOf('day').unix();
    endOfDay = day.endOf('day').unix();
    return this.filter((function(_this) {
      return function(time) {
        var ref;
        return (startOfDay <= (ref = time.start().unix()) && ref <= endOfDay);
      };
    })(this));
  };

  return Availability;

})(Booking.Collections.Base);

Booking.Collections.Options = (function(superClass) {
  extend(Options, superClass);

  function Options() {
    return Options.__super__.constructor.apply(this, arguments);
  }

  Options.prototype.model = Booking.Models.Option;

  Options.prototype.selectable = function() {
    return this.filter(function(option) {
      return option.isSoldOut() === false;
    });
  };

  Options.prototype.firstSelectable = function() {
    return this.selectable()[0];
  };

  Options.prototype.cheapest = function() {
    return this.sortBy(function(option) {
      return option.getPrice();
    })[0];
  };

  Options.prototype.isFoodAndDrink = function() {
    return this.some(function(option) {
      return option.isFoodAndDrink();
    });
  };

  return Options;

})(Booking.Collections.Base);

Booking.Collections.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  function PartySizes() {
    return PartySizes.__super__.constructor.apply(this, arguments);
  }

  PartySizes.prototype.model = Booking.Models.PartySize;

  return PartySizes;

})(Booking.Collections.Base);

Booking.Collections.Reservations = (function(superClass) {
  extend(Reservations, superClass);

  function Reservations() {
    return Reservations.__super__.constructor.apply(this, arguments);
  }

  Reservations.prototype.model = Booking.Models.Reservation;

  Reservations.prototype.url = function() {
    return Booking.rootUrl + "/reservations";
  };

  return Reservations;

})(Booking.Collections.Base);

Booking.Collections.Times = (function(superClass) {
  extend(Times, superClass);

  function Times() {
    return Times.__super__.constructor.apply(this, arguments);
  }

  Times.prototype.model = Booking.Models.Time;

  return Times;

})(Booking.Collections.Base);

Booking.Presenters.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.toHash = function() {
    var bookAndBuy, isDisabled, notYet, requestAppointment, reschedule;
    isDisabled = this.model.isBooking() || !this.model.isReadyToBook();
    notYet = this.model.isDealNotYetOpen();
    bookAndBuy = this.model.isBookAndBuy();
    reschedule = this.model.isReschedule();
    requestAppointment = this.model.isARSE();
    return {
      isDisabled: isDisabled,
      notYet: notYet,
      bookAndBuy: bookAndBuy,
      reschedule: reschedule,
      requestAppointment: requestAppointment
    };
  };

  return Book;

})(Booking.Presenters.Base);

Booking.Presenters.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  function Reservation() {
    Booking.Presenters.Base.apply(this, arguments);
    this.isARSE = this.model.isAppointmentRequest();
    if (this.isARSE) {
      this.localesBasePath = this.localesBasePath + "_arse";
    }
  }

  Reservation.prototype.toHash = function() {
    var dateMoment, hash, location;
    if (!this.model.getError()) {
      if (this.model.isLoaded()) {
        dateMoment = this.model.getStartDatetimeMoment();
        location = this.model.getLocationName();
        if ((location != null ? location.length : void 0) === 0) {
          location = this.model.getMerchantName();
        }
        hash = {
          loaded: true,
          isLocked: this.model.isLocked(),
          isBooked: this.model.isBooked(),
          isExpired: this.model.isExpired(),
          date: dateMoment != null ? dateMoment.format('dddd, MMMM Do YYYY') : void 0,
          time: dateMoment != null ? dateMoment.format('h:mm a') : void 0,
          location: location,
          service: this.model.getOption().getTitle()
        };
        if (this.isARSE) {
          hash.endtime = this.model.getEndDatetimeMoment().format('h:mm a');
        }
      } else {
        hash = {
          loaded: false
        };
      }
    } else {
      hash = {
        error: this.model.getError()
      };
    }
    return _.extend(hash, {
      contactSupportLink: this.generateLink('.contact_support', 'https://www.groupon.com/customer_support'),
      myReservationsLink: this.generateLink('.my_reservations', "/users/" + (this.model.getUserId()) + "/reservations")
    });
  };

  return Reservation;

})(Booking.Presenters.Base);

Booking.Presenters.Picker = (function(superClass) {
  extend(Picker, superClass);

  function Picker() {
    return Picker.__super__.constructor.apply(this, arguments);
  }

  Picker.prototype.selected = function() {
    return this.model.get(this.options.selected);
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1;
  };

  Picker.prototype.toHash = function() {
    return {
      icon: this.options.icon,
      expanded: this.options.expanded,
      selectable: this.isSelectable() || !this.selected()
    };
  };

  return Picker;

})(Booking.Presenters.Base);

Booking.Presenters.Booker = (function(superClass) {
  extend(Booker, superClass);

  function Booker() {
    var ref;
    Booking.Presenters.Base.apply(this, arguments);
    this.isARSE = (ref = this.model.getCurrentOption()) != null ? ref.isARSE() : void 0;
    if (this.isARSE) {
      this.localesBasePath = this.localesBasePath + "_arse";
    }
  }

  Booker.prototype.userPageHref = function(page) {
    return "/users/" + (this.model.getUserId()) + "/" + page;
  };

  Booker.prototype.toHash = function() {
    var error, hash, ref;
    error = this.model.getError();
    hash = {
      error: error,
      errorLoading: error === 'loading' || error === 'timeout',
      errorBooking: error === 'server' || error === 'not_found',
      errorSegmentNotAvailable: error === 'conflict',
      errorSegmentExpired: error === 'gone',
      myReservationsLink: this.generateLink('.my_reservations', this.userPageHref('reservations')),
      myGrouponsLink: this.generateLink('.my_groupons', this.userPageHref('groupons')),
      isOpen: this.options.isOpen,
      isLocked: this.options.isLocked,
      phoneRequired: this.model.requirePhone(),
      questionRequired: this.model.requireQuestion(),
      isARSE: this.isARSE,
      showNewOverlay: this.options.showNewOverlay,
      hasReservation: ((ref = this.model.getReservation()) != null ? ref.id : void 0) != null,
      merchantPhone: this.model.getMerchantPhoneNumber()
    };
    return hash;
  };

  return Booker;

})(Booking.Presenters.Base);

Booking.Presenters.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  function Calendar() {
    return Calendar.__super__.constructor.apply(this, arguments);
  }

  Calendar.prototype.toHash = function() {
    var calendarData, days, firstDayIndex, j, lastDayIndex, lastMonthAvailable, momentEndOfMonth, momentStartOfMonth, nextMonthAvailable, now, numberOfColumns, numberOfRows, ref, row, rows;
    calendarData = this.options.calendarData;
    numberOfColumns = calendarData.days.length / calendarData.numberOfRows;
    numberOfRows = calendarData.numberOfRows;
    rows = [];
    now = moment();
    days = _.map(calendarData.days, function(day, i) {
      var at, diff, label, value;
      label = day.events.length ? 'available' : 'unavailable';
      if (moment.isMoment(day.date)) {
        diff = day.date.diff(now, 'days');
        if (diff) {
          at = diff > 0 ? 'ahead' : 'behind';
          value = at + "-" + (Math.abs(diff));
        } else {
          value = 'today';
        }
      } else {
        value = i < calendarData.days.length / 2 ? 'last-month' : 'next-month';
      }
      day.bhc = label + ":" + value;
      return day;
    });
    for (row = j = 0, ref = numberOfRows - 1; 0 <= ref ? j <= ref : j >= ref; row = 0 <= ref ? ++j : --j) {
      firstDayIndex = row * numberOfColumns;
      lastDayIndex = (row + 1) * numberOfColumns - 1;
      rows[row] = {
        days: days.slice(firstDayIndex, +lastDayIndex + 1 || 9e9)
      };
    }
    momentStartOfMonth = moment(calendarData.month + " " + calendarData.year, 'MMM YYYY').startOf('month');
    momentEndOfMonth = moment(momentStartOfMonth).endOf('month');
    lastMonthAvailable = !!this.collection.filter(function(time) {
      return time.get('initialTimeMoment') < momentStartOfMonth;
    }).length;
    nextMonthAvailable = !!this.collection.filter(function(time) {
      return time.get('initialTimeMoment') > momentEndOfMonth;
    }).length;
    return {
      loaded: this.collection.isLoaded(),
      rows: rows,
      month: calendarData.month,
      daysOfTheWeek: calendarData.daysOfTheWeek,
      lastMonthAvailable: lastMonthAvailable,
      nextMonthAvailable: nextMonthAvailable
    };
  };

  return Calendar;

})(Booking.Presenters.Base);

Booking.Presenters.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.toHash = function() {
    var date, hash, loading, selected;
    selected = this.selected();
    date = selected != null ? selected.date : void 0;
    loading = date === true;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    hash.loading = loading;
    if (!loading && date) {
      hash.selectedDate = {
        month: date.format('MMMM'),
        date: date.format('D'),
        year: date.format('YYYY')
      };
    }
    return hash;
  };

  return DatePicker;

})(Booking.Presenters.Picker);

Booking.Presenters.EditableReservation = (function(superClass) {
  extend(EditableReservation, superClass);

  function EditableReservation() {
    return EditableReservation.__super__.constructor.apply(this, arguments);
  }

  EditableReservation.prototype.toHash = function() {
    var dateMoment, hash;
    hash = Booking.Presenters.Reservation.prototype.toHash.apply(this, arguments);
    hash.loading = this.model.isLoading();
    if (this.model.isBooked()) {
      dateMoment = this.model.getStartDatetimeMoment();
      hash.date = dateMoment.format('ddd, MMM D, YYYY');
      hash.time = dateMoment.format('h:mma');
      hash.partySize = this.model.getPartySize();
    }
    return hash;
  };

  return EditableReservation;

})(Booking.Presenters.Reservation);

Booking.Presenters.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.toHash = function() {
    var option, selectedOption;
    selectedOption = this.model.selectedOption();
    option = selectedOption || this.model.getOptions().cheapest();
    return {
      optionSelected: selectedOption != null,
      price: option.getFormattedPrice()
    };
  };

  return Info;

})(Booking.Presenters.Base);

Booking.Presenters.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.toHash = function() {
    var optionId, ref, selectedOptionId;
    optionId = this.model.id;
    selectedOptionId = (ref = this.options.selected) != null ? ref.id : void 0;
    return {
      optionId: optionId,
      title: this.model.getTitle(),
      selected: selectedOptionId === optionId,
      price: this.model.getFormattedPrice(),
      value: this.model.getFormattedValue(),
      isSoldOut: this.model.isSoldOut(),
      discount: this.model.getDiscount()
    };
  };

  Option.prototype.bhc = function() {
    return "dealoption:" + (this.model.getTitle());
  };

  return Option;

})(Booking.Presenters.Base);

Booking.Presenters.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.toHash = function() {
    var hash;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedOption = {
        title: this.selected().getTitle()
      };
    }
    return hash;
  };

  return OptionPicker;

})(Booking.Presenters.Picker);

Booking.Presenters.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.toHash = function() {
    var partySize, ref, selected;
    if (this.model) {
      partySize = this.model.getPartySize();
      selected = ((ref = this.options.selected) != null ? ref.getPartySize() : void 0) === partySize;
      return {
        partySize: partySize,
        selected: selected
      };
    }
  };

  PartySize.prototype.bhc = function() {
    return "partysize:" + (this.model.getPartySize());
  };

  return PartySize;

})(Booking.Presenters.Base);

Booking.Presenters.PartyPicker = (function(superClass) {
  extend(PartyPicker, superClass);

  function PartyPicker() {
    return PartyPicker.__super__.constructor.apply(this, arguments);
  }

  PartyPicker.prototype.toHash = function() {
    var hash;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedpartySize = {
        partySize: this.selected().getPartySize()
      };
    }
    return hash;
  };

  return PartyPicker;

})(Booking.Presenters.Picker);

Booking.Presenters.Phone = (function(superClass) {
  extend(Phone, superClass);

  function Phone() {
    return Phone.__super__.constructor.apply(this, arguments);
  }

  Phone.prototype.toHash = function() {
    return {
      customerPhone: this.options.customerPhone,
      maxLength: this.options.customerPhoneMaxLength,
      bhw: Booking.bhw + "Phone"
    };
  };

  return Phone;

})(Booking.Presenters.Base);

Booking.Presenters.Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.prototype.toHash = function() {
    return {
      question: this.options.question,
      answer: this.options.answer,
      maxLength: this.options.maxLength,
      bhw: Booking.bhw + "Question"
    };
  };

  return Question;

})(Booking.Presenters.Base);

Booking.Presenters.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.timeHash = function(momentTime) {
    return {
      hours: momentTime.format('h'),
      minutes: momentTime.format('mm'),
      period: momentTime.format('a')
    };
  };

  Time.prototype.isRange = function() {
    var ref;
    return (ref = this.collection) != null ? typeof ref.isARSE === "function" ? ref.isARSE() : void 0 : void 0;
  };

  Time.prototype.modelToHash = function(model, selection) {
    var from, id, isRange, selected, time, to;
    id = model.id;
    isRange = this.isRange();
    from = this.timeHash(model.start().tz(model.collection.getTimezone()));
    if (isRange) {
      to = this.timeHash(model.end().tz(model.collection.getTimezone()));
    }
    selected = id === (selection != null ? selection.id : void 0);
    time = {
      id: id,
      isRange: isRange,
      from: from,
      to: to,
      selected: selected
    };
    return {
      time: time
    };
  };

  Time.prototype.toHash = function() {
    var ref;
    if (this.model) {
      return this.modelToHash(this.model, (ref = this.options) != null ? ref.selected : void 0);
    }
  };

  Time.prototype.bhc = function() {
    var from, isRange, label, ref, time, to, value;
    ref = this.toHash().time, from = ref.from, to = ref.to, isRange = ref.isRange;
    time = function(t) {
      return t.hours + "." + t.minutes + t.period;
    };
    label = 'time';
    value = time(from);
    if (isRange) {
      label = 'range';
      value = value + "-" + (time(to));
    }
    return label + ":" + value;
  };

  return Time;

})(Booking.Presenters.Base);

Booking.Presenters.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  function TimePicker(options, templateName) {
    Booking.Presenters.Picker.apply(this, arguments);
    this.timePresenter = new Booking.Presenters.Time(options, templateName);
  }

  TimePicker.prototype.toHash = function() {
    var hash, loading, selected, selection;
    selected = this.selected();
    loading = selected === true;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    hash.loading = loading;
    if (!loading) {
      if (selected) {
        selection = this.timePresenter.modelToHash(selected);
      }
      hash.selection = selection != null ? selection.time : void 0;
      hash.isRange = this.timePresenter.isRange();
    }
    return hash;
  };

  return TimePicker;

})(Booking.Presenters.Picker);

Booking.Views.Picker = (function(superClass) {
  extend(Picker, superClass);

  Picker.prototype.templateName = 'picker';

  Picker.prototype.expandedClassName = 'expanded';

  Picker.prototype.collapsedClassName = 'collapsed';

  Picker.prototype.selectEvent = 'select';

  Picker.prototype.renderedEvent = 'rendered';

  Picker.prototype.events = {
    'click .dropdown': 'toggle'
  };

  Picker.prototype.transitionDuration = 300;

  Picker.prototype.className = function() {
    var className;
    className = "picker " + this.collapsedClassName + " " + this.styleClassName;
    return className;
  };

  function Picker() {
    Booking.Views.Base.apply(this, arguments);
    this.collection.on('reset', this.clearSelection, this);
    this.collection.on('request', this.clearSelection, this);
    this.model.on("change:" + this.options.selected, (function(_this) {
      return function(model, selection) {
        _this.content().options.selected = selection;
        return _this.render();
      };
    })(this));
  }

  Picker.prototype.render = function() {
    this.content().$el.detach();
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.appendContent();
    this.trigger(this.renderedEvent);
    if (!this.isSelectable() && this.collection.first()) {
      this.setSelection(this.collection.first());
    }
    return this;
  };

  Picker.prototype.content = function() {
    if (!this._content) {
      this._content = new this.contentView({
        collection: this.collection,
        selected: this.selected()
      });
      this._content.on('select', this.select, this);
      this._content.render();
    }
    return this._content;
  };

  Picker.prototype.select = function(selection) {
    this.setSelection(selection);
    this.render();
    return this.trigger(this.selectEvent, selection);
  };

  Picker.prototype.selected = function() {
    return this.model.get(this.options.selected);
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1;
  };

  Picker.prototype.setSelection = function(selection) {
    return this.model.set(this.options.selected, selection);
  };

  Picker.prototype.clearSelection = function() {
    this.setSelection(null);
    return this.render();
  };

  Picker.prototype.container = function() {
    return this.$el.find('.content');
  };

  Picker.prototype.appendContent = function() {
    return this.content().$el.appendTo(this.container());
  };

  Picker.prototype.isPreviousSelected = function() {
    if (this.options.previous) {
      return this.options.previous.selected();
    } else {
      return true;
    }
  };

  Picker.prototype.toggle = function() {
    if (this.collection.length && this.isSelectable()) {
      if (this.isVisible()) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  };

  Picker.prototype.isVisible = function() {
    return this.$el.hasClass(this.expandedClassName);
  };

  Picker.prototype.show = function() {
    var transitionEndHandler;
    if (this.isPreviousSelected()) {
      this.redraw();
      this.trigger('expand', this);
      transitionEndHandler = (function(_this) {
        return function() {
          return _this.trigger('expanded', _this);
        };
      })(this);
      setTimeout(transitionEndHandler, this.transitionDuration);
      return this.$el.removeClass(this.collapsedClassName).addClass(this.expandedClassName);
    }
  };

  Picker.prototype.hide = function(force) {
    var transitionEndHandler;
    if (this.isPreviousSelected() && this.selected() || force === true) {
      this.redraw();
      this.trigger('collapse', this);
      transitionEndHandler = (function(_this) {
        return function() {
          _this.trigger('collapsed', _this);
          return _this.$el.addClass(_this.collapsedClassName);
        };
      })(this);
      setTimeout(transitionEndHandler, this.transitionDuration);
      return this.$el.removeClass(this.expandedClassName);
    }
  };

  Picker.prototype.redraw = function() {
    return this.$el.get(0).offsetHeight;
  };

  return Picker;

})(Booking.Views.Base);

Booking.Views.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  Reservation.prototype.presenter = Booking.Presenters.Reservation;

  Reservation.prototype.templateName = 'reservation';

  Reservation.prototype.events = {
    'click a.reload': 'reload'
  };

  function Reservation() {
    Booking.Views.Base.apply(this, arguments);
    this.bhw(Booking.bhw + "Reservation");
    this.model.on('change:loaded', this.render, this);
  }

  Reservation.prototype.reload = function() {
    return window.location.reload();
  };

  return Reservation;

})(Booking.Views.Base);

Booking.Views.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.presenter = Booking.Presenters.Book;

  Book.prototype.templateName = 'book';

  Book.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "BookButton"
    };
  };

  return Book;

})(Booking.Views.Base);

Booking.Views.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.presenter = Booking.Presenters.Booker;

  Booker.prototype.infoView = Booking.Views.Info;

  Booker.prototype.pickersView = Booking.Views.Pickers;

  Booker.prototype.optionPickerView = Booking.Views.OptionPicker;

  Booker.prototype.partySizePickerView = Booking.Views.PartySizePicker;

  Booker.prototype.datePickerView = Booking.Views.DatePicker;

  Booker.prototype.timePickerView = Booking.Views.TimePicker;

  Booker.prototype.questionView = Booking.Views.Question;

  Booker.prototype.phoneView = Booking.Views.Phone;

  Booker.prototype.bookButtonView = Booking.Views.Book;

  Booker.prototype.events = {
    'submit form': 'book',
    'click .open .btn': 'open',
    'click form > .icon-close': 'close'
  };

  Booker.prototype.className = 'booking-component';

  function Booker() {
    this.clearQuestionsAnswer = bind(this.clearQuestionsAnswer, this);
    this.setQuestionsAnswer = bind(this.setQuestionsAnswer, this);
    this.clearPhoneNumber = bind(this.clearPhoneNumber, this);
    this.setPhoneNumber = bind(this.setPhoneNumber, this);
    this.selectPartySize = bind(this.selectPartySize, this);
    this.selectTime = bind(this.selectTime, this);
    this.selectDate = bind(this.selectDate, this);
    this.selectOption = bind(this.selectOption, this);
    Booking.Views.Base.apply(this, arguments);
    this.model.getAvailability().on('error', this.errorLoading, this);
    this.model.getReservations().on('error', this.errorBooking, this);
    this.model.on('change:selectedOption', this.renderInfo, this);
    this.model.on('change:selectedOption', this.renderQuestion, this);
    this.model.on('change:selectedOption', this.renderPhone, this);
    this.model.on('change:selectedTime', this.renderBookButton, this);
    this.model.on('change:phoneNumber', this.renderBookButton, this);
    this.model.on('change:questionsAnswer', this.renderBookButton, this);
    this.model.on('change:isBooking', this.renderBookButton, this);
  }

  Booker.prototype.canRenderOptions = function() {
    return this.options.optionSelectable && this.model.hasMultipleOptions();
  };

  Booker.prototype.canRenderPartySize = function() {
    return this.model.requirePartySize();
  };

  Booker.prototype.canRenderQuestion = function() {
    return this.model.requireQuestion();
  };

  Booker.prototype.canRenderPhone = function() {
    return this.model.requirePhone();
  };

  Booker.prototype.setOpen = function() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    return this.options.isOpen = true;
  };

  Booker.prototype.setOpenAndLocked = function() {
    this.setOpen();
    return this.options.isLocked = true;
  };

  Booker.prototype.setClosed = function() {
    return this.options.isOpen = false;
  };

  Booker.prototype.open = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-opened", null);
    this.setOpen();
    this.model.reset();
    return this.render({
      fadeIn: true
    });
  };

  Booker.prototype.close = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-closed", null);
    this.setClosed();
    return this.$el.fadeOut((function(_this) {
      return function() {
        _this.render({
          show: true
        });
        if (_this.options.overlapWith) {
          $(_this.options.overlapWith).fadeIn();
        }
        return _this.model.resetOption();
      };
    })(this));
  };

  Booker.prototype.canBeClosed = function() {
    return this.options.isOpen && !this.options.keepOpen;
  };

  Booker.prototype.render = function() {
    var ref, ref1;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (!this.model.getError()) {
      if (this.options.isOpen || this.options.keepOpen) {
        this.renderInfo();
        this.renderPickers();
        this.renderQuestion();
        this.renderPhone();
        this.renderBookButton();
      }
    }
    if (((ref = arguments[0]) != null ? ref.fadeIn : void 0) === true) {
      this.$el.fadeIn();
    }
    if (((ref1 = arguments[0]) != null ? ref1.show : void 0) === true) {
      this.$el.show();
    }
    return this;
  };

  Booker.prototype.renderInfo = function() {
    var infoContainer;
    infoContainer = this.$el.find('[data-info-content]');
    if (infoContainer.length) {
      return infoContainer.html((new this.infoView({
        model: this.model
      })).render().el);
    }
  };

  Booker.prototype.renderPickers = function() {
    var pickersView;
    pickersView = new this.pickersView({
      el: this.$el.find('[data-pickers-content]')
    });
    if (this.canRenderOptions()) {
      pickersView.add({
        view: this.optionPickerView,
        model: this.model,
        collection: 'options',
        selection: 'selectedOption',
        selected: this.selectOption
      });
    }
    if (this.canRenderPartySize()) {
      pickersView.add({
        view: this.partySizePickerView,
        model: this.model,
        collection: 'partySizes',
        selection: 'selectedPartySize',
        selected: this.selectPartySize
      });
    }
    this.datePicker = pickersView.add({
      view: this.datePickerView,
      model: this.model,
      collection: 'availability',
      selection: 'selectedDate',
      selected: this.selectDate
    });
    this.timePicker = pickersView.add({
      view: this.timePickerView,
      model: this.model,
      collection: 'times',
      selection: 'selectedTime',
      selected: this.selectTime
    });
    pickersView.render();
    pickersView.on('collapse', (function(_this) {
      return function() {
        return _this.pickersCollapsed();
      };
    })(this));
    return pickersView.once('expanded', (function(_this) {
      return function() {
        return _this.trigger('ready');
      };
    })(this));
  };

  Booker.prototype.renderQuestion = function() {
    var questionEl;
    questionEl = this.$el.find('[data-question-content]');
    if (!this.canRenderQuestion()) {
      return questionEl.html('');
    }
    this.questionInput = new this.questionView({
      el: questionEl,
      maxLength: this.options.metasSettings.answerMaxLength,
      question: this.model.getQuestion(),
      answer: this.model.getQuestionsAnswer()
    });
    this.questionInput.render();
    this.questionInput.on('complete', this.setQuestionsAnswer, this);
    return this.questionInput.on('incomplete', this.clearQuestionsAnswer, this);
  };

  Booker.prototype.renderPhone = function() {
    var phoneEl;
    phoneEl = this.$el.find('[data-phone-content]');
    if (!this.canRenderPhone()) {
      return phoneEl.html('');
    }
    this.phoneInput = new this.phoneView({
      el: phoneEl,
      customerPhoneMaxLength: this.options.metasSettings.customerPhoneMaxLength,
      customerPhone: this.model.getPhoneNumber()
    });
    this.phoneInput.render();
    this.phoneInput.on('complete', this.setPhoneNumber, this);
    return this.phoneInput.on('incomplete', this.clearPhoneNumber, this);
  };

  Booker.prototype.pickersCollapsed = function() {
    if (this.model.requireQuestion() && !this.model.getQuestionsAnswer()) {
      return this.questionInput.focus();
    } else if (this.model.requirePhone() && !this.model.getPhoneNumber()) {
      return this.phoneInput.focus();
    }
  };

  Booker.prototype.renderBookButton = function() {
    var bookContainer;
    bookContainer = this.$el.find('[data-book-now-content]');
    if (bookContainer.length) {
      return bookContainer.html((new this.bookButtonView({
        model: this.model
      })).render().el);
    }
  };

  Booker.prototype.selectOption = function(option) {
    return this.model.selectOption(option);
  };

  Booker.prototype.selectDate = function(date) {
    return this.model.selectDate(date);
  };

  Booker.prototype.selectTime = function(time) {
    return this.model.selectTime(time);
  };

  Booker.prototype.selectPartySize = function(partySize) {
    return this.model.selectPartySize(partySize);
  };

  Booker.prototype.setPhoneNumber = function(phoneNumber) {
    return this.model.setPhoneNumber(phoneNumber);
  };

  Booker.prototype.clearPhoneNumber = function() {
    return this.setPhoneNumber(void 0);
  };

  Booker.prototype.setQuestionsAnswer = function(answer) {
    return this.model.setQuestionsAnswer(answer);
  };

  Booker.prototype.clearQuestionsAnswer = function() {
    return this.setQuestionsAnswer(void 0);
  };

  Booker.prototype.book = function(event) {
    event.stopPropagation();
    this.model.book();
    return false;
  };

  Booker.prototype.errorLoading = function() {
    return this.error('loading');
  };

  Booker.prototype.errorBooking = function(reservation) {
    return this.error(reservation.getError());
  };

  Booker.prototype.error = function(error) {
    this.model.setError(error);
    if (this.canBeClosed()) {
      return this.close();
    } else {
      return this.render();
    }
  };

  return Booker;

})(Booking.Views.Base);

Booking.Views.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  Calendar.prototype.presenter = Booking.Presenters.Calendar;

  Calendar.prototype.templateName = 'calendar';

  Calendar.prototype.selectedClass = 'selected';

  function Calendar() {
    Booking.Views.Base.apply(this, arguments);
    this.collection.on('request', this.setEvents, this);
    this.collection.on('sync', this.setEvents, this);
  }

  Calendar.prototype.setEvents = function() {
    var ref;
    if ((ref = this.calendar) != null) {
      ref.setEvents(this.collection.toJSON());
    }
    return this.select();
  };

  Calendar.prototype.render = function() {
    this.calendar = this.$el.clndr(this.CLNDRparams());
    this.select();
    return this;
  };

  Calendar.prototype.detach = function() {
    return this.$el.detach();
  };

  Calendar.prototype.toggle = function() {
    return this.$el.toggle();
  };

  Calendar.prototype.hide = function() {
    return this.$el.hide();
  };

  Calendar.prototype.select = function() {
    var ref, ref1;
    if (moment.isMoment((ref = this.options.selected) != null ? ref.date : void 0)) {
      return (ref1 = this.calendar) != null ? ref1.element.find(".calendar-day-" + (this.options.selected.date.format('YYYY-MM-DD'))).addClass(this.selectedClass) : void 0;
    }
  };

  Calendar.prototype.unselect = function() {
    return this.calendar.element.find("." + this.selectedClass).removeClass(this.selectedClass);
  };

  Calendar.prototype.selectDate = function(selection) {
    if (selection.events.length) {
      this.unselect();
      this.options.selected = selection;
      this.trigger('select', selection, this);
      return this.select();
    }
  };

  Calendar.prototype.renderCalendar = function(data) {
    var presenter;
    presenter = new this.presenter({
      calendarData: data,
      collection: this.collection
    });
    return this.template().render(presenter.toHashWithHelpers());
  };

  Calendar.prototype.CLNDRparams = function() {
    var ref, ref1, startWithMonth, timeMomentField;
    timeMomentField = 'clndrTimeMoment';
    startWithMonth = moment.isMoment((ref = this.options.selected) != null ? ref.date : void 0) ? this.options.selected.date : (ref1 = this.collection.first()) != null ? ref1.get(timeMomentField) : void 0;
    return {
      showAdjacentMonths: false,
      dateParameter: timeMomentField,
      startWithMonth: startWithMonth,
      events: this.collection.toJSON(),
      render: _.bind(this.renderCalendar, this),
      clickEvents: {
        click: _.bind(this.selectDate, this)
      },
      targets: {
        nextButton: 'next',
        previousButton: 'previous',
        day: 'day',
        empty: 'unavailable'
      }
    };
  };

  return Calendar;

})(Booking.Views.Base);

Booking.Views.Collection = (function(superClass) {
  extend(Collection, superClass);

  Collection.prototype.containerSelector = '[yield]';

  function Collection() {
    var ref, ref1, ref2, ref3;
    Booking.Views.Base.apply(this, arguments);
    if ((ref = this.collection) != null) {
      ref.on('add', (function(_this) {
        return function(model) {
          return _this.appendChildView(model);
        };
      })(this));
    }
    if ((ref1 = this.collection) != null) {
      ref1.on('remove', (function(_this) {
        return function(model) {
          return _this.removeChildView(model);
        };
      })(this));
    }
    if ((ref2 = this.collection) != null) {
      ref2.on('reset', this.render, this);
    }
    if ((ref3 = this.collection) != null) {
      ref3.on('sort', this.render, this);
    }
  }

  Collection.prototype.container = function() {
    var container;
    container = this.$el.find(this.containerSelector);
    if (container.length) {
      return container;
    } else {
      return this.$el;
    }
  };

  Collection.prototype.render = function() {
    var i, limit, models;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (this.collection) {
      models = this.collection.models;
      limit = this.options.limit && models.length > this.options.limit ? this.options.limit : models.length;
      i = 0;
      while (i < limit) {
        this.appendChildView(models[i]);
        i++;
      }
    }
    return this;
  };

  Collection.prototype.appendChildView = function(model) {
    return this.renderChildView('append', model);
  };

  Collection.prototype.prependChildView = function(model) {
    return this.renderChildView('prepend', model);
  };

  Collection.prototype.renderChildView = function(insert, model) {
    var childView, options;
    options = {
      model: model,
      id: model != null ? model.id : void 0
    };
    childView = new this.childView(_.extend(options, _.omit(this.options, 'el')));
    childView.on('all', this.bubbleUpEvent, this);
    this.container()[insert](childView.render().el);
    return this;
  };

  Collection.prototype.removeChildView = function(model) {
    return this.container().find("#" + model.id).remove();
  };

  Collection.prototype.bubbleUpEvent = function() {
    return this.trigger.apply(this, arguments);
  };

  return Collection;

})(Booking.Views.Base);

Booking.Views.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.presenter = Booking.Presenters.DatePicker;

  DatePicker.prototype.contentView = Booking.Views.Calendar;

  DatePicker.prototype.templateName = 'datepicker';

  DatePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "Dates"
    };
  };

  DatePicker.prototype.styleClassName = 'dates';

  DatePicker.prototype.isSelectable = function() {
    return true;
  };

  return DatePicker;

})(Booking.Views.Picker);

Booking.Views.EditableReservation = (function(superClass) {
  extend(EditableReservation, superClass);

  EditableReservation.prototype.presenter = Booking.Presenters.EditableReservation;

  EditableReservation.prototype.events = function() {
    var events;
    events = Booking.Views.Reservation.prototype.events;
    events['click .open-booker'] = 'openBooker';
    events['click .reschedule-reservation'] = 'openBooker';
    events['click .cancel-reservation'] = 'cancelReservation';
    return events;
  };

  function EditableReservation() {
    Booking.Views.Reservation.apply(this, arguments);
    this.model.on('sync', this.updateReservation, this).on('error', this.updateReservation, this);
  }

  EditableReservation.prototype.bookerView = function() {
    return this.options.bookerView;
  };

  EditableReservation.prototype.bookerModel = function() {
    return this.bookerView().model;
  };

  EditableReservation.prototype.bookerElement = function() {
    return this.bookerView().render().$el;
  };

  EditableReservation.prototype.cancelReservation = function(e) {
    e.preventDefault();
    if (confirm(this.translate('.cancel_confirmation'))) {
      return this.model.cancel();
    }
  };

  EditableReservation.prototype.openBooker = function(e) {
    var options;
    if (e != null) {
      e.preventDefault();
    }
    if (e != null) {
      e.stopPropagation();
    }
    this.bookerView().setOpen();
    this.bookerModel().getAvailability().on('error', this.closeBooker, this);
    this.bookerModel().clearError().loadAvailability();
    options = {
      destroyOnClose: false,
      closeOnBgClick: false,
      closeOnEscKey: false
    };
    this.bookerModel().getReservations().on('request', this.closeBooker, this).on('sync', this.updateReservation, this).on('error', this.updateReservation, this);
    return GIG.Modal.create(this.bookerElement(), options);
  };

  EditableReservation.prototype.closeBooker = function() {
    GIG.Modal.close();
    this.bookerView().setClosed();
    return this.render();
  };

  EditableReservation.prototype.updateReservation = function() {
    this.model = this.bookerModel().getReservation();
    if (this.model.isLocked()) {
      return this.bookerModel().preset({
        partySize: this.model.getPartySize(),
        questionsAnswer: this.model.getQuestion(),
        phoneNumber: this.model.getPhone()
      });
    } else {
      return this.bookerModel().resetDate().resetTime();
    }
  };

  return EditableReservation;

})(Booking.Views.Reservation);

Booking.Views.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.presenter = Booking.Presenters.Info;

  Info.prototype.templateName = 'info';

  return Info;

})(Booking.Views.Base);

Booking.Views.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.presenter = Booking.Presenters.Option;

  Option.prototype.templateName = 'option';

  Option.prototype.tagName = 'li';

  Option.prototype.events = {
    'click': 'select'
  };

  Option.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  Option.prototype.select = function() {
    if (!this.model.isSoldOut()) {
      return this.trigger('select', this.model);
    }
  };

  return Option;

})(Booking.Views.Base);

Booking.Views.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.presenter = Booking.Presenters.OptionPicker;

  OptionPicker.prototype.contentView = Booking.Views.Options;

  OptionPicker.prototype.templateName = 'optionpicker';

  OptionPicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "DealOptions"
    };
  };

  OptionPicker.prototype.styleClassName = 'options';

  return OptionPicker;

})(Booking.Views.Picker);

Booking.Views.Options = (function(superClass) {
  extend(Options, superClass);

  Options.prototype.tagName = 'ul';

  Options.prototype.childView = Booking.Views.Option;

  function Options() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Options.prototype.select = function(option) {
    this.options.selected = option;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return Options;

})(Booking.Views.Collection);

Booking.Views.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.presenter = Booking.Presenters.PartySize;

  PartySize.prototype.templateName = 'partysize';

  PartySize.prototype.tagName = 'li';

  PartySize.prototype.events = {
    'click': 'select'
  };

  PartySize.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  PartySize.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  return PartySize;

})(Booking.Views.Base);

Booking.Views.PartySizePicker = (function(superClass) {
  extend(PartySizePicker, superClass);

  function PartySizePicker() {
    return PartySizePicker.__super__.constructor.apply(this, arguments);
  }

  PartySizePicker.prototype.presenter = Booking.Presenters.PartyPicker;

  PartySizePicker.prototype.contentView = Booking.Views.PartySizes;

  PartySizePicker.prototype.templateName = 'partysizepicker';

  PartySizePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "PartySizes"
    };
  };

  PartySizePicker.prototype.styleClassName = 'party-sizes';

  return PartySizePicker;

})(Booking.Views.Picker);

Booking.Views.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  PartySizes.prototype.templateName = 'partysizes';

  PartySizes.prototype.childView = Booking.Views.PartySize;

  function PartySizes() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  PartySizes.prototype.select = function(partySize) {
    this.options.selected = partySize;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return PartySizes;

})(Booking.Views.Collection);

Booking.Views.Phone = (function(superClass) {
  extend(Phone, superClass);

  function Phone() {
    return Phone.__super__.constructor.apply(this, arguments);
  }

  Phone.prototype.presenter = Booking.Presenters.Phone;

  Phone.prototype.templateName = 'phone';

  Phone.prototype.maxDigitCount = 10;

  Phone.prototype.events = {
    'keypress input': 'formatPhoneNumber',
    'paste input': 'dismissPasteEvent',
    'keyup input': 'triggerEvents',
    'change input': 'clearable',
    'keydown input': 'clearable',
    'click .clear': 'clear'
  };

  Phone.prototype.render = function() {
    var base;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$input = this.$el.find('input');
    this.input = this.$input.get(0);
    if (typeof (base = this.$input).PlaceholderField === "function") {
      base.PlaceholderField();
    }
    this.clearable();
    return this;
  };

  Phone.prototype.isntDigitOrControlKey = function(charCode) {
    return charCode > 31 && (charCode < 48 || charCode > 57);
  };

  Phone.prototype.formatPhoneNumber = function(e) {
    var digit, length, re, value;
    if (this.isntDigitOrControlKey(e.which)) {
      return false;
    }
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return true;
    }
    value = this.input.value;
    length = (value.replace(/\D/g, '') + digit).length;
    if (length > this.maxDigitCount) {
      e.preventDefault();
      this.input.value = value;
      return;
    }
    if ((this.$input.prop('selectionStart') != null) && this.$input.prop('selectionStart') !== value.length) {
      return;
    }
    re = /^(\d{3}|\d{3}\-\d{3})$/;
    if (re.test(value)) {
      e.preventDefault();
      return this.input.value = value + "-" + digit;
    } else if (re.test(value + digit)) {
      e.preventDefault();
      return this.input.value = "" + value + digit + "-";
    }
  };

  Phone.prototype.triggerEvents = function() {
    var event, value;
    value = this.$input.val();
    event = value.length === this.options.customerPhoneMaxLength ? 'complete' : 'incomplete';
    return this.trigger(event, value);
  };

  Phone.prototype.dismissPasteEvent = function() {
    return false;
  };

  Phone.prototype.focus = function() {
    return this.input.focus();
  };

  Phone.prototype.clearable = function() {
    var method;
    method = this.input.value.length ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Phone.prototype.clear = function() {
    this.input.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  return Phone;

})(Booking.Views.Base);

Booking.Views.Pickers = (function(superClass) {
  extend(Pickers, superClass);

  function Pickers() {
    return Pickers.__super__.constructor.apply(this, arguments);
  }

  Pickers.prototype.add = function(arg) {
    var collection, model, picker, selected, selection, view;
    view = arg.view, model = arg.model, collection = arg.collection, selection = arg.selection, selected = arg.selected;
    if (this.pickers == null) {
      this.pickers = [];
    }
    picker = new view({
      model: model,
      collection: model.get(collection),
      selected: selection,
      previous: this.pickers[this.pickers.length - 1]
    });
    picker.on('select', (function(_this) {
      return function(selection) {
        var nextPicker;
        selected(selection);
        nextPicker = _this.nextUnselectedPicker();
        if (nextPicker) {
          _this.collapse(true);
          return _this.expand(nextPicker);
        } else {
          _this.trigger('collapse');
          picker.once('collapsed', function() {
            return _this.trigger('collapsed');
          });
          return _this.collapse(false);
        }
      };
    })(this));
    picker.on('expand', (function(_this) {
      return function(picker) {
        if (_this.picker) {
          _this.collapse(true);
        }
        return _this.setActivePicker(picker);
      };
    })(this));
    picker.on('collapse', this.unsetActivePicker, this);
    this.pickers.push(picker);
    return picker;
  };

  Pickers.prototype.expanded = function() {
    var picker;
    if ((function() {
      var j, len, ref, results;
      ref = this.pickers;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        picker = ref[j];
        results.push(picker.isVisible);
      }
      return results;
    }).call(this)) {
      return true;
    }
    return false;
  };

  Pickers.prototype.render = function() {
    var j, len, picker, ref;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    ref = this.pickers;
    for (j = 0, len = ref.length; j < len; j++) {
      picker = ref[j];
      this.$el.append(picker.render().el);
    }
    setTimeout(((function(_this) {
      return function() {
        return _this.postRender();
      };
    })(this)), 1000);
    return this;
  };

  Pickers.prototype.postRender = function() {
    var picker;
    picker = this.firstNotSelected();
    if (picker) {
      return this.expand(picker);
    }
  };

  Pickers.prototype.expand = function(picker) {
    picker.show();
    return picker.once('expanded', (function(_this) {
      return function() {
        return _this.trigger('expanded');
      };
    })(this));
  };

  Pickers.prototype.nextUnselectedPicker = function() {
    return _.find(this.pickers, function(picker) {
      return !picker.selected();
    });
  };

  Pickers.prototype.collapse = function() {
    return this.picker.hide(true);
  };

  Pickers.prototype.setActivePicker = function(picker) {
    if (picker) {
      this.picker = picker;
    }
    return picker;
  };

  Pickers.prototype.unsetActivePicker = function() {
    return delete this.picker;
  };

  Pickers.prototype.firstNotSelected = function() {
    return _.find(this.pickers, function(picker) {
      return !picker.selected();
    });
  };

  return Pickers;

})(Booking.Views.Base);

Booking.Views.Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.prototype.presenter = Booking.Presenters.Question;

  Question.prototype.templateName = 'question';

  Question.prototype.events = {
    'click .label': 'focus',
    'blur textarea': 'willBlur',
    'change textarea': 'refreshStatus',
    'keyup textarea': 'refreshStatus',
    'keydown textarea': 'refreshStatus',
    'keypress textarea': 'newText',
    'paste textarea': 'truncatePaste',
    'click .clear': 'clear'
  };

  Question.prototype.render = function() {
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$textarea = this.$el.find('textarea');
    this.textarea = this.$textarea.get(0);
    this.$textarea.autosize();
    this.updateLabel(this.$textarea.val());
    return this.refreshStatus();
  };

  Question.prototype.focus = function() {
    clearTimeout(this.willBlurTimer);
    this.updateLabel();
    this.$el.addClass('expanded');
    return this.$textarea.focus();
  };

  Question.prototype.willBlur = function() {
    return this.willBlurTimer = setTimeout(((function(_this) {
      return function() {
        return _this.blur();
      };
    })(this)), 10);
  };

  Question.prototype.blur = function() {
    this.$el.removeClass('expanded');
    this.updateLabel(this.$textarea.val());
    return this.triggerEvents();
  };

  Question.prototype.updateLabel = function(value) {
    if (!value) {
      value = this.options.question;
    }
    return this.$el.find('.label').html(value);
  };

  Question.prototype.refreshStatus = function() {
    this.clearable();
    return this.triggerEvents();
  };

  Question.prototype.newText = function() {
    var maxLength;
    this.refreshStatus();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      if (this.textarea.value.length >= maxLength) {
        this.textarea.value = this.textarea.value.slice(0, maxLength);
        return false;
      }
    }
  };

  Question.prototype.truncatePaste = function(e) {
    var maxLength, paste;
    this.clearable();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      paste = e.originalEvent.clipboardData.getData('Text');
      if (this.textarea.value.length + paste.length >= maxLength) {
        this.textarea.value += paste.slice(0, maxLength - this.textarea.value.length);
        return false;
      }
    }
  };

  Question.prototype.clearable = function() {
    var method;
    method = this.textarea.value.length ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Question.prototype.clear = function() {
    clearTimeout(this.willBlurTimer);
    this.textarea.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  Question.prototype.triggerEvents = function() {
    var event, value;
    value = this.textarea.value;
    event = value.length ? 'complete' : 'incomplete';
    return this.trigger(event, value);
  };

  return Question;

})(Booking.Views.Base);

Booking.Views.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.presenter = Booking.Presenters.Time;

  Time.prototype.templateName = 'time';

  Time.prototype.tagName = 'li';

  Time.prototype.events = {
    'click': 'select'
  };

  Time.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  Time.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  return Time;

})(Booking.Views.Base);

Booking.Views.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  function TimePicker() {
    return TimePicker.__super__.constructor.apply(this, arguments);
  }

  TimePicker.prototype.presenter = Booking.Presenters.TimePicker;

  TimePicker.prototype.contentView = Booking.Views.Times;

  TimePicker.prototype.templateName = 'timepicker';

  TimePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "Times"
    };
  };

  TimePicker.prototype.styleClassName = 'times';

  TimePicker.prototype.isSelectable = function() {
    return true;
  };

  return TimePicker;

})(Booking.Views.Picker);

Booking.Views.Times = (function(superClass) {
  extend(Times, superClass);

  Times.prototype.templateName = 'times';

  Times.prototype.childView = Booking.Views.Time;

  function Times() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Times.prototype.select = function(time) {
    this.options.selected = time;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return Times;

})(Booking.Views.Collection);

Booking.dealBookerInit = function(payload, done) {
  var datetime, deal, el, error, failed, metasSettings, model, optionId, overlapWith, partySize, phoneNumber, questionsAnswer, timezoneData, view;
  if (done == null) {
    done = function() {};
  }
  if (!payload) {
    return done();
  }
  Booking.bhw = 'BookingEngineDealBooker';
  deal = payload.deal, timezoneData = payload.timezoneData, el = payload.el, failed = payload.failed, error = payload.error, overlapWith = payload.overlapWith, metasSettings = payload.metasSettings, optionId = payload.optionId, partySize = payload.partySize, datetime = payload.datetime, questionsAnswer = payload.questionsAnswer, phoneNumber = payload.phoneNumber;
  moment.tz.add(timezoneData);
  model = new Booking.Models.Booker({
    deal: deal,
    bookAndBuy: true
  });
  model.preset({
    optionId: optionId,
    partySize: partySize,
    datetime: datetime,
    questionsAnswer: questionsAnswer,
    phoneNumber: phoneNumber
  });
  if (!model.get('options').selectable().length) {
    return done();
  }
  view = new Booking.Views.Booker({
    optionSelectable: true,
    el: el || '#deal-booker',
    overlapWith: overlapWith || '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card',
    model: model,
    templateName: 'deal_booker',
    metasSettings: metasSettings
  });
  model.get('availability').on('error', function() {
    return failed != null ? failed.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('error', function() {
    return error != null ? error.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('sync', function(reservation) {
    var option;
    option = model.get('options').get(reservation.getOption().id);
    return view.trigger('buy', option, reservation);
  });
  view.on('buy', function(option, reservation) {
    var buyUrl, separator;
    buyUrl = option.get('buyUrl');
    if (reservation) {
      separator = buyUrl.match(/\?/) ? '&' : '?';
      buyUrl += separator + "booking_reservation_id=" + (reservation.get('id'));
    }
    return window.location = buyUrl;
  });
  return $(function() {
    if (!$('#purchase-cluster .buy').length) {
      view.setOpenAndLocked();
    }
    view.render();
    return done();
  });
};
  return Booking;
})();